export const getMonthNumber = (month: string) => {
  const months = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
  ];

  const monthIndex = months.findIndex(
    (m) => m.toLowerCase() === month.toLowerCase()
  );

  if (monthIndex !== -1) {
    return (monthIndex + 1).toString().padStart(2, '0');
  } else {
    return null;
  }
};
